export const NAME = "name";
export const CATEGORY = "category";
export const PRIORITY = "priority";
export const TERM = "term";
export const DUE_DATE = "dueDate";
export const TASK_STATUS = "taskStatus";
export const TASK_ATTACHMENT = "taskAttachment";
export const SCHOOL = "school";
export const ROLE = "role";
export const ASSIGN_TO = "assignTo";
export const TASKS = "tasks";
export const NOTES = "notes";
export const DESCRIPTION = "description";
